import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M39.8297 16.3785H38.2498V16.2971H20.5973V24.1426H31.6821C30.0649 28.7097 25.7194 31.9882 20.5973 31.9882C14.0982 31.9882 8.82895 26.7189 8.82895 20.2198C8.82895 13.7208 14.0982 8.45151 20.5973 8.45151C23.5972 8.45151 26.3265 9.58323 28.4046 11.4318L33.9524 5.88405C30.4493 2.61932 25.7636 0.605957 20.5973 0.605957C9.76552 0.605957 0.983398 9.38807 0.983398 20.2198C0.983398 31.0516 9.76552 39.8337 20.5973 39.8337C31.4291 39.8337 40.2112 31.0516 40.2112 20.2198C40.2112 18.9047 40.0758 17.621 39.8297 16.3785Z",
                fill: "#FFC107"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.24512 11.0901L9.68926 15.816C11.4329 11.499 15.6558 8.45102 20.5975 8.45102C23.5975 8.45102 26.3267 9.58274 28.4048 11.4314L33.9526 5.88357C30.4496 2.61883 25.7638 0.605469 20.5975 0.605469C13.0638 0.605469 6.53044 4.85874 3.24512 11.0901Z",
                fill: "#FF3D00"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.597 39.8344C25.6633 39.8344 30.2667 37.8956 33.7471 34.7427L27.6766 29.6058C25.6412 31.1537 23.1541 31.9909 20.597 31.9889C15.4954 31.9889 11.1637 28.7359 9.53183 24.1963L3.13574 29.1243C6.38184 35.4762 12.9741 39.8344 20.597 39.8344Z",
                fill: "#4CAF50"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M39.8301 16.3783H38.2502V16.2969H20.5977V24.1424H31.6824C30.9089 26.3161 29.5155 28.2154 27.6743 29.6059L27.6773 29.6039L33.7478 34.7408C33.3182 35.1311 40.2115 30.0266 40.2115 20.2197C40.2115 18.9045 40.0762 17.6208 39.8301 16.3783Z",
                fill: "#1976D2"
            })
        ]
    }));
};
export default Icon;
